import React, { useEffect, useState } from "react";
import DataTable from "../../Utils/GenericUI/DataTable";
import { USER_DATA_HEADER as header } from "../../Utils/StaticData/DashboardHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserManagementData,
  // getUserRoleChangeData1,
  getUserRoleChangeData,
} from "../../Redux/Actions/UserManagementAction";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import RadioGroup from "@material-ui/core/RadioGroup";
// import Radio from "@material-ui/core/Radio";
import FormControl from "@material-ui/core/FormControl";
import PopUp from "./PopUp";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import AutoComplete1 from "../../Utils/Select";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

const roles = [
  {
    label: "AGENT",
    value: "AGENT",
  },
  {
    label: "SUPER_USER",
    value: "SUPER_USER",
  },
  {
    label: "AGENCY_ADMIN",
    value: "AGENCY_ADMIN",
  },
];

const UserManagement = (props) => {
  const [userDetails, setUserDetails] = useState({
    agencyId: "",
    agentId: "",
    emailId: "",
    firstName: "",
    lastName: "",
    roleDesc: "",
    userId: "",
  });

  const [userInfo, setUserInfo] = useState(userDetails);
  const [userData, setUserData] = useState([]);
  const [isPage, setPage] = useState(0);
  const [selectAllPage, setSelectAllPage] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [doubleClick, setDoubleClick] = useState(0);
  const [showModal, setShowModal] = useState(false);
  //const [assignValue, setAssignValue] = useState(""); Sonar..
  const [roleChange, setRoleChange] = useState(null);
  const [selectedCount, setSelectedCount] = useState(0);
  const [filterData, setFilterData] = useState([]);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [snackBarMsg, setSnackBarMsg] = useState("");
  const [vertical] = useState("top");
  const [horizontal] = useState("center");

  const UserManagementDataFiltered = useSelector(
    (state) => state.user.UserManagementDataFiltered
  );
  const dispatch = useDispatch();

  const handleChangeRowsPerPage = async (rowsPerPage1) => {
    setRowsPerPage(rowsPerPage1);
  };

  const generateFilename = () => {
    let date = new Date();
    let date1 = `User data extract_${moment(date).format(
      "MMMM/Do/YYYY, h:mm:ss a"
    )}`;

    return date1;
  };
  const handleCheck = (val) => {
    setUserData(val);
    const newSelectedCount = val.filter((item) => item.checked === "Y");
    setSelectedCount(newSelectedCount.length);
  };

  const handleCheckBox = async (name, val, index) => {
    let value = val === "Y" ? "N" : "Y";

    let data = [...userData];
    let dataIndex = data.findIndex((x) => x.firstName === name);
    data[dataIndex].checked = value;
    let filteredData = data.filter((x) => x.checked === "Y");
    setFilterData(filteredData);
    setUserData(data);

    const newSelectedCount =
      value === "Y" ? selectedCount + 1 : selectedCount - 1;
    setSelectedCount(newSelectedCount);
  };

  const SelectAllHandleCheckBox = (
    rowsCount,
    selectAll,
    val,
    page,
    selectedRow,
    data1
  ) => {
    let caseData = data1;
    const a = page * rowsCount + rowsCount;
    let b = 0;
    if (a > caseData.length) {
      b = caseData.length;
    } else {
      b = a;
    }
    let filteredData = [];
    if (page < 1) {
      let data = caseData;
      for (let i = 0; i < b; i++) {
        data[i].checked = val;
      }
      filteredData = data.filter((x) => x.checked === "Y");
      setFilterData(filteredData);
    } else {
      let data = caseData;
      for (let i = page * rowsCount; i < b; i++) {
        data[i].checked = val;
      }
      filteredData = data.filter((x) => x.checked === "Y");
      setFilterData(filteredData);
    }
    setSelectedCount(filteredData.length);
  };

  const rowSelect = async (index, selectedData, rowsPerPage1, type) => {
    setUserInfo(selectedData);
    setSelectedRowIndex(index);
  };

  const handleSelect = (value) => {
    setRoleChange(value);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const userManagementRowSelectFirst = async (index) => {
    setSelectedRowIndex(index);
  };

  const handleSubmit = async () => {
    let filter = [...filterData].map((item) => ({
      ...item,
      roleDesc: roleChange.value,
    }));

    const payload = {
      userDetailsList: filterData,
      newRoleDesc: roleChange.value,
    };

    // Dispatch the action to change the user roles
    let response = dispatch(getUserRoleChangeData(payload));
    response.then((value) => {
      if (value?.data?.status !== "FAILURE") {
        const updatedUserData = userData.map((user) =>
          filter.find((item) => item.userId === user.userId)
            ? { ...user, roleDesc: roleChange.value, checked: "N" }
            : { ...user, checked: "N" }
        );

        setUserData(updatedUserData);
        setSelectedCount(0); // Reset selected count
        setFilterData([]); // Clear filter data

        // Reset role changes
        setRoleChange(null);
        setSelectAllPage(true);
        // Show snackbar
        setSnackBarSeverity("success");
        setSnackBarMsg("Role changed successfully!");
        setSnackBarOpen(true);
      } else {
        setSnackBarSeverity("error");
        setSnackBarMsg(value?.data?.message);
        setSnackBarOpen(true);
      }
      closeModal();
    });
  };

  useEffect(() => {
    dispatch(getUserManagementData());
  }, []);

  // useEffect(() => {
  //   if (props.checkedList && props.checkedList.length === 0) {
  //     setAssignValue("");
  //   }
  // }, [props.checkedList]);  .. Sonar
 
  useEffect(() => {
    setUserData(UserManagementDataFiltered);
  }, [UserManagementDataFiltered]);

  const saveData = (data, isPage1) => {
    setUserData(data);
    setPage(isPage1);
  };

  const unSelectAllPage = (val) => {
    setSelectAllPage(val);
  };
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          className="btn btn-dashboard-active mb-2 ml-2 btn-dashboard-active-color"
          onClick={openModal}
          disabled={selectedCount < 1}
        >
          Change Role
        </button>
      </div>

      <div>
        <div className="container-campaignmain prospecttablealign mt-5 mb-3">
          <DataTable
            fontSize="small"
            width="100%"
            modalSelect={doubleClick === 2 ? "#usermangmntPopup" : ""}
            doubleClick={true}
            setClick={(x) => setDoubleClick(x)}
            padding="4px 20px 4px 4px"
            paddingRight="60px"
            dashboard="userManagement"
            data={userData}
            header={header}
            exportAsExcel={true}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[10, 15, 20]}
            index={selectedRowIndex}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            sortable={true}
            searchable={true}
            status={generateFilename()}
            dateColumn="createdTime"
            clicked={rowSelect}
            SelectAllHandleCheckBox={SelectAllHandleCheckBox}
            isCheckBoxNeeded={true}
            selectedCount={selectedCount}
            handleCheckBox={handleCheckBox}
            clickedFirst={userManagementRowSelectFirst}
            UserManagementDataFiltered={UserManagementDataFiltered}
            saveData={saveData}
            handleCheck={handleCheck}
            isPage={isPage}
            selectAllPage={selectAllPage}
            unSelectAllPage={unSelectAllPage}
          />
        </div>
        <PopUp
          userDetails={userInfo}
          setUserDetails={setUserDetails}
          setSnackBarSeverity={setSnackBarSeverity}
          setSnackBarMsg={setSnackBarMsg}
          setSnackBarOpen={setSnackBarOpen}
        />
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        size={"lg"}
        centered
        scrollable={true}
        backdrop="static"
      >
        <Modal.Header className="modal-header-background">
          <Modal.Title className={"piechart-header-position"}>
            Change Role
          </Modal.Title>
          <button type="button" className="close" onClick={closeModal}>
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <span className="label-container">
            <label htmlFor="prospect_assigned_to" className="labelprospect">
              Role Change<span className="mandatory-field">*</span>
            </label>
            <br />
            <AutoComplete1
              dashboard="prospect"
              height="7px !important"
              width="236px"
              field="changeRole"
              handleChange={handleSelect}
              options={roles}
              value={roleChange}
              name="changeRole"
            />
          </span>
          <button
            className="btn btn-dashboard-active mb-0 ml-2 mt-2"
            onClick={handleSubmit}
          >
            Change
          </button>
        </Modal.Body>
      </Modal>
      <Modal.Footer>
        <Snackbar
          open={snackBarOpen}
          autoHideDuration={6000}
          onClose={() => setSnackBarOpen(false)}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert
            onClose={() => setSnackBarOpen(false)}
            severity={snackBarSeverity}
          >
            {snackBarMsg}
          </Alert>
        </Snackbar>
      </Modal.Footer>
    </>
  );
};

export default UserManagement;
